import {User} from 'auth/user'
import PanelsDashboard from 'Event/template/Panels/Dashboard'
import React, {useEffect} from 'react'
import {useHistory} from 'react-router-dom'

export default function Speakers(props: {user: User}) {
  const history = useHistory()

  useEffect(() => {
    history.push({
      search: 'tab=speakers',
    })
  }, [history])

  return <PanelsDashboard user={props.user} />
}
